import { Table, Badge, Text, ActionIcon, Tooltip, Group, Code } from '@mantine/core'
import { IconRefresh, IconTrash } from '@tabler/icons-react'
import type { ConnectorItem } from '@/api/connectors'

const ENV_COLORS: Record<string, string> = {
  DEV: 'gray', QA: 'blue', HML: 'orange', PRD: 'red',
}

const STATUS_COLORS: Record<string, string> = {
  pending: 'yellow', active: 'green', revoked: 'red',
}

export interface ConnectorRowProps {
  connector: ConnectorItem
  tenantName?: string
  onRevoke: (c: ConnectorItem) => void
  onRenew: (c: ConnectorItem) => void
}

export default function ConnectorRow({
  connector,
  tenantName,
  onRevoke,
  onRenew,
}: ConnectorRowProps) {
  const fp = connector.cert_fingerprint
  const fpShort = fp.length > 12 ? `${fp.slice(0, 6)}…${fp.slice(-6)}` : fp
  const isRevoked = connector.status === 'revoked'
  return (
    <Table.Tr>
      <Table.Td>{tenantName ?? `#${connector.tenant_id}`}</Table.Td>
      <Table.Td>
        <Badge color={ENV_COLORS[connector.environment] ?? 'gray'} variant="light">
          {connector.environment}
        </Badge>
      </Table.Td>
      <Table.Td>
        <Group gap="xs">
          <Badge color={STATUS_COLORS[connector.status] ?? 'gray'} variant="light">
            {connector.status}
          </Badge>
          {connector.online && (
            <Badge color="teal" variant="filled" size="xs">
              online
            </Badge>
          )}
        </Group>
      </Table.Td>
      <Table.Td>
        <Tooltip label={fp}>
          <Code>{fpShort}</Code>
        </Tooltip>
      </Table.Td>
      <Table.Td>
        {connector.last_seen_at ? (
          <Text size="sm" c="dimmed">
            {new Date(connector.last_seen_at).toLocaleString()}
          </Text>
        ) : (
          <Text size="sm" c="dimmed">—</Text>
        )}
      </Table.Td>
      <Table.Td>
        <Group gap="xs">
          <Tooltip label="Renovar cert (rotate)">
            <ActionIcon
              variant="subtle"
              color="blue"
              onClick={() => onRenew(connector)}
              disabled={isRevoked}
              aria-label={`Renovar connector ${fpShort}`}
              data-testid={`renew-${connector.cert_fingerprint}`}
            >
              <IconRefresh size={16} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="Revogar cert">
            <ActionIcon
              variant="subtle"
              color="red"
              onClick={() => onRevoke(connector)}
              disabled={isRevoked}
              aria-label={`Revogar connector ${fpShort}`}
            >
              <IconTrash size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Table.Td>
    </Table.Tr>
  )
}
